import React, { useState, useEffect } from "react";
import SimpleBar from "simplebar-react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartPie,
  faCog,
  faSignOutAlt,
  faTimes,
  faBoxes,
  faMoneyBill,
  faMoneyBillAlt,
  faBuilding,
} from "@fortawesome/free-solid-svg-icons";
import { Nav, Badge, Image, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { parsedUser } from "../../common/GetCurrentUser";
import { Routes } from "../../routes";
import logoAvocado from "../../assets/img/logo_zaboka_avocado.png";
import logo from "../../assets/img/logoLetterZaboka_w.png";
import { useTranslation } from "react-i18next";

const Sidebar = ({ show = false, isOverlay = false, onClose = () => {} }) => {
  const location = useLocation();
  const { pathname } = location;
  const { t } = useTranslation("global");
  const [user, setUser] = useState(null);

  useEffect(() => {
    setUser(parsedUser());
  }, []);

  const NavItem = (props) => {
    const {
      title,
      link,
      external,
      target,
      icon,
      image,
      badgeText,
      badgeBg = "secondary",
      badgeColor = "primary",
    } = props;
    const classNames = badgeText
      ? "d-flex justify-content-start align-items-center justify-content-between"
      : "";
    const navItemClassName = link === pathname ? "active" : "";
    const linkProps = external ? { href: link } : { as: Link, to: link };

    return (
      <Nav.Item
        className={navItemClassName}
        onClick={() => isOverlay && onClose()}
      >
        <Nav.Link {...linkProps} target={target} className={classNames}>
          <span>
            {icon ? (
              <span className="sidebar-icon">
                <FontAwesomeIcon icon={icon} />{" "}
              </span>
            ) : null}
            {image ? (
              <Image
                src={image}
                width={20}
                height={20}
                className="sidebar-icon svg-icon"
              />
            ) : null}

            <span className="sidebar-text">{title}</span>
          </span>
          {badgeText ? (
            <Badge
              pill
              bg={badgeBg}
              text={badgeColor}
              className="badge-md notification-count ms-2"
            >
              {badgeText}
            </Badge>
          ) : null}
        </Nav.Link>
      </Nav.Item>
    );
  };

  return (
    <>
      <SimpleBar
        id="main-sidebar"
        role="navigation"
        aria-label="Navegación principal"
        aria-hidden={!show}
        className={`sidebar app-sidebar bg-primary text-white ${
          show ? "is-open" : "is-closed"
        }`}
      >
        <div className="sidebar-inner px-3 px-lg-4 pt-3">
          <div className="sidebar-brand-row d-flex align-items-center justify-content-between mb-3">
            <Link to={Routes.Home.path} onClick={() => isOverlay && onClose()}>
              <img
                src={logo}
                alt="Zaboka"
                className="sidebar-brand"
              />
            </Link>
            <Button
              type="button"
              variant="link"
              className="sidebar-close text-white"
              aria-label="Cerrar menú"
              onClick={onClose}
            >
              <FontAwesomeIcon icon={faTimes} />
            </Button>
          </div>

          <div className="user-card d-flex d-xl-none align-items-center justify-content-between pb-3 mb-2">
            <div className="d-flex align-items-center min-w-0">
              <div className="d-block text-truncate">
                <small className="d-block text-white-50">Sesión activa</small>
                <span className="d-block text-truncate">
                  {user && (user.Email || user.email)}
                </span>
              </div>
            </div>
            <Button
              as={Link}
              variant="secondary"
              size="sm"
              to={Routes.SignIn.path}
              className="text-dark ms-2 flex-shrink-0"
            >
              <FontAwesomeIcon icon={faSignOutAlt} />
              <span className="visually-hidden">Cerrar sesión</span>
            </Button>
          </div>

          <Nav className="flex-column pt-2">
            <NavItem
              title={t("Inicio")}
              link={Routes.Home.path}
              icon={faChartPie}
            />
            <NavItem
              title={t("Dashboard")}
              icon={faChartPie}
              link={Routes.DashboardPage.path}
            />
            <NavItem
              title="Inventario"
              icon={faBoxes}
              link={Routes.Inventory.path}
            />
            <NavItem
              title="Franquicias"
              icon={faBuilding}
              link={Routes.Franchise.clean}
            />
            <NavItem
              title="Ventas"
              icon={faMoneyBill}
              link={Routes.Sales.clean}
            />
            <NavItem
              title="Resumen de Ventas"
              icon={faMoneyBillAlt}
              link={Routes.SalesRecord.clean}
            />
            <NavItem
              title="Reportes"
              icon={faChartPie}
              link={Routes.Reports.clean + "admin"}
            />
            <NavItem
              title="Configuración"
              icon={faCog}
              link={Routes.Settings.path}
            />
            <div className="sidebar-footer-logo text-center mt-auto pt-3">
              <img src={logoAvocado} alt="" />
            </div>
          </Nav>
        </div>
      </SimpleBar>

      {show && isOverlay ? (
        <button
          type="button"
          className="sidebar-backdrop"
          aria-label="Cerrar menú lateral"
          onClick={onClose}
        />
      ) : null}
    </>
  );
};

export default Sidebar;
